import { Spin } from 'antd';
import type { SpinProps } from 'antd';
import './Loader.css';

export interface LoaderProps {
	/**
	 * Display variant
	 * - `inline`     — small spinner for use inside containers (e.g. table footer)
	 * - `page`       — centered spinner with optional message, fills parent
	 * - `fullscreen` — fixed overlay covering the entire viewport
	 * @default 'page'
	 */
	variant?: 'inline' | 'page' | 'fullscreen';
	/**
	 * Spinner size — maps to Ant Design Spin sizes
	 * @default 'large' for page/fullscreen, 'small' for inline
	 */
	size?: SpinProps['size'];
	/**
	 * Optional message shown below the spinner
	 */
	message?: string;
}

export function Loader({ variant = 'page', size, message }: LoaderProps) {
	const resolvedSize = size ?? (variant === 'inline' ? 'small' : 'large');

	if (variant === 'inline') {
		return (
			<div className="loader loader--inline">
				<Spin size={resolvedSize} />
			</div>
		);
	}

	if (variant === 'fullscreen') {
		return (
			<div className="loader loader--fullscreen">
				<div className="loader__content">
					<Spin size={resolvedSize} />
					{message && <p className="loader__message">{message}</p>}
				</div>
			</div>
		);
	}

	// page (default)
	return (
		<div className="loader loader--page">
			<Spin size={resolvedSize} />
			{message && <p className="loader__message">{message}</p>}
		</div>
	);
}

Loader.displayName = 'Loader';
